export default __webpack_public_path__ + "static/media/7.467631c6.jpg";